import { FormProvider } from 'react-hook-form';
import { CategorySelector } from './CategorySelector';
import QuestionComponent from './QuestionComponent';
import { Toaster } from 'react-hot-toast';
import { UbigeoQuestion } from './UbigeoQuestion';
import { HobbyQuestion } from './HobbyQuestion';
import { formatQuestion } from '../utils/formatQuestion';
import { useCallback, useMemo } from 'react';

export const FormContent = ({
  categories,
  nameForm,
  activeCategoryIndex,
  setActiveCategoryIndex,
  methods,
  onSubmit,
  questionsByCategory,
  activeCategory,
  goToPreviousCategory,
  disabledFields,
  departments,
  provinces,
  districts,
  errorDepartment,
  errorProvince,
  errorDistrict,
  disabledSearchFields
}) => {

  
  const currentCategoryQuestions = questionsByCategory[activeCategory] || [];

  const isUbigeoQuestion = useCallback(
    (description) =>
      description.toLowerCase().includes('departamento') ||
      description.toLowerCase().includes('provincia') ||
      description.toLowerCase().includes('distrito'),
    []
  );

  const isHobbyQuestion = useCallback(
    (description) => description.toLowerCase().includes('hobbies'),
    []
  );

  const formErrors = useMemo(() => methods.formState.errors, [methods.formState.errors]);

  return (
    <>
      <div className="flex justify-between bg-white p-4 py-6 rounded-lg shadow-md mb-6">
        <h2 className="text-xl font-semibold">{nameForm}</h2>
      </div>

      <CategorySelector
        categories={categories}
        activeCategoryIndex={activeCategoryIndex}
        setActiveCategoryIndex={setActiveCategoryIndex}
      />

      <FormProvider {...methods}>
        <form
          onSubmit={methods.handleSubmit(onSubmit)}
          className="bg-white p-4 rounded-lg"
        >
          {currentCategoryQuestions.map((question) => {
            const { id, description } = question;
            
            if (isUbigeoQuestion(description)) {
              return (
                <UbigeoQuestion
                  key={id}
                  question={question}
                  methods={methods}
                  departments={departments}
                  provinces={provinces}
                  districts={districts}
                  errorDepartment={errorDepartment}
                  errorProvince={errorProvince}
                  errorDistrict={errorDistrict}
                />
              );
            }

            if (isHobbyQuestion(description)) {
              return <HobbyQuestion key={id} question={question} />;
            }

            return (
              <QuestionComponent
                key={id}
                question={question}
                options={question.options}
                disabled={
                  disabledFields[
                    `question_${formatQuestion(description)}`
                  ] ||
                  disabledSearchFields[
                    `question_${formatQuestion(description)}`
                  ]
                }
              />
            );
          })}

          {formErrors && Object.keys(formErrors).length > 0 && (
            <div className="text-red-500 mt-2">
              Por favor, complete todos los campos requeridos.
            </div>
          )}

          {methods.formState.errors && Object.keys(methods.formState.errors).length > 0 && (
            <div className="text-red-500 mt-2">
              Por favor, complete todos los campos requeridos.
            </div>
          )}

          <div className="flex justify-between mt-4">
            <button
              type="button"
              className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded inline-flex items-center"
              onClick={goToPreviousCategory}
              disabled={activeCategoryIndex === 0}
            >
              Previo
            </button>
            <button
              type="submit"
              className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded inline-flex items-center"
            >
              {activeCategoryIndex === categories.length - 1
                ? 'Finalizar'
                : 'Siguiente'}
            </button>
          </div>
        </form>
      </FormProvider>
      <Toaster />
    </>
  );
};